/**
 * @generated SignedSource<<58f11b88f97aa8656c0ef6e8ab15ffa0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4Apps$data = {
  readonly appsOrder?: {
    readonly " $fragmentSpreads": FragmentRefs<"Nav4AppsContent_navigationCustomisation">;
  } | null;
  readonly jira: {
    readonly " $fragmentSpreads": FragmentRefs<"Nav4AppsForLanding" | "Nav4Apps_GlobalAppsFragment">;
  };
  readonly " $fragmentType": "Nav4Apps";
};
export type Nav4Apps$key = {
  readonly " $data"?: Nav4Apps$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4Apps">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "entityAriApps"
    },
    {
      "kind": "RootArgument",
      "name": "isAppsExpanded"
    },
    {
      "kind": "RootArgument",
      "name": "ownerAri"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "skipOrderQuery"
    }
  ],
  "kind": "Fragment",
  "name": "Nav4Apps",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "isAppsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "Nav4AppsForLanding"
              }
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "Nav4Apps_GlobalAppsFragment"
          }
        ]
      },
      "action": "THROW"
    },
    {
      "condition": "skipOrderQuery",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "condition": "isAppsExpanded",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": "appsOrder",
              "args": [
                {
                  "kind": "Variable",
                  "name": "entityAri",
                  "variableName": "entityAriApps"
                },
                {
                  "kind": "Variable",
                  "name": "ownerAri",
                  "variableName": "ownerAri"
                }
              ],
              "concreteType": "SettingsNavigationCustomisation",
              "kind": "LinkedField",
              "name": "settings_navigationCustomisation",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "Nav4AppsContent_navigationCustomisation"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "c4548a7973b987d15b97b369b8bc4314";

export default node;
